/******************************************************************************

Copyright (c) 2016-2018, Highsoft

Permission is hereby granted, free of charge, to any person obtaining
a copy of this software and associated documentation files (the
"Software"), to deal in the Software without restriction, including
without limitation the rights to use, copy, modify, merge, publish,
distribute, sublicense, and/or sell copies of the Software, and to
permit persons to whom the Software is furnished to do so, subject to
the following conditions:

The above copyright notice and this permission notice shall be
included in all copies or substantial portions of the Software.

THE SOFTWARE IS PROVIDED "AS IS", WITHOUT WARRANTY OF ANY KIND,
EXPRESS OR IMPLIED, INCLUDING BUT NOT LIMITED TO THE WARRANTIES OF
MERCHANTABILITY, FITNESS FOR A PARTICULAR PURPOSE AND NONINFRINGEMENT.
IN NO EVENT SHALL THE AUTHORS OR COPYRIGHT HOLDERS BE LIABLE FOR ANY
CLAIM, DAMAGES OR OTHER LIABILITY, WHETHER IN AN ACTION OF CONTRACT,
TORT OR OTHERWISE, ARISING FROM, OUT OF OR IN CONNECTION WITH THE
SOFTWARE OR THE USE OR OTHER DEALINGS IN THE SOFTWARE.

******************************************************************************/

import { isStr, isNum } from "../../core/highcharts-editor";

export function rowsToColumns(rows) {
  let row,
      rowsLength,
      col,
      colsLength,
      columns;

  if (rows) {
      columns = [];
      rowsLength = rows.length;
      for (row = 0; row < rowsLength; row++) {
          colsLength = rows[row].length;
          for (col = 0; col < colsLength; col++) {
              if (!columns[col]) {
                  columns[col] = [];
              }
              columns[col][row] = rows[row][col];
          }
      }
  }
  return columns;
}

export function getNextLetter(key) {
  if (key === 'Z' || key === 'z') {
    return String.fromCharCode(key.charCodeAt() - 25) + String.fromCharCode(key.charCodeAt() - 25);
  } else {
    let lastChar = key.slice(-1);
    let sub = key.slice(0, -1);
    if (lastChar === 'Z' || lastChar === 'z') {
      return getNextLetter(sub) + String.fromCharCode(lastChar.charCodeAt() - 25);
    } else {
      return sub + String.fromCharCode(lastChar.charCodeAt() + 1);
    }
  }
  return key;
};

export function checkSections(sections, index) {
  return (sections || []).some(function(section) {
    return (section.dataColumns.indexOf(index) > -1 || (section.extraColumns && section.extraColumns.indexOf(index) > -1) || section.labelColumn === index);
  });
}

export function shuffleArray(arr, min, amount, moveTo) {
  let x = arr.splice(min, amount);
  let args = [moveTo, 0].concat(x);
  Array.prototype.splice.apply(arr, args);
}


/** Sort rows
 * @memberof DataTable
 * @param column {number} - the column to sort on
 * @param direction {string} - the direction: `asc` or `desc`
 * @param asMonths {boolean} - if true, sort by month
 */
export function rowSort(rows, column, direction, asMonths) {
  direction = (direction || '').toUpperCase();
  rows.sort((a, b) => {
    let ad = a.columns[column].getValue(),
      bd = b.columns[column].getValue();

    if ((isNum(ad) && isNum(bd)) || asMonths) {
      if (asMonths) {
        ad = model.monthNumbers[ad.toUpperCase().substr(0, 3)] || 13;
        bd = model.monthNumbers[bd.toUpperCase().substr(0, 3)] || 13;
      } else {
        ad = parseFloat(ad);
        bd = parseFloat(bd);
      }

      if (direction === 'ASC') {
        return ad - bd;
      }

      return bd < ad ? -1 : bd > ad ? 1 : 0;
    } else if (ad === null){
      return 1;
    } 
    else if (bd === null){
      return -1;
    }

    if (direction === 'ASC') {
      if (!ad) return bd;
      return ad.localeCompare(bd);
    }

    if (bd) {
      if (!ad) return bd;
      return (bd.toString()).localeCompare(ad);
    }
      else {
        if (ad) {
          return ad.localeCompare(bd);
        }
      }
    
  });
}
  
export function rebuildRows(rows, emitChanged) {
  rows.forEach((row, i) => {
    if (rows.length < 500) {
      row.addToDOM(i);
    }
    row.rowIndex = i;
  });
  emitChanged();
}

export function focusFirstCell(rows){
  if (rows.length > 0) rows[0].columns[0].focus();
}

export function rebuildColumns(rows) {
  rows.forEach((row) => {
    row.rebuildColumns();
  });
}



  /** Get the table contents as series
   *  @memberof DataTable
   */
  export function toDataSeries(ignoreFirst) {
    let res = {
      categories: [],
      series: []
    };

    this.tableHeader.forEach((item, i) => {
      if (i > 0) {
        res.series.push({
          name: item.headerTitle.innerHTML.length
            ? item.headerTitle.innerHTML
            : null,
          data: []
        });
      }
    });
    model.rows.forEach((row, i) => {
      row.columns.forEach((col, ci) => {
        let v = col.getVal();

        if (!ci) {
          if (v && isStr(v) && Date.parse(v) !== NaN) {
            // v = new Date(v);
          }

          res.categories.push(v);
          return;
        }

        ci--;

        if (v && isNum(v)) {
          v = parseFloat(v);
        }

        if (v && isStr(v) && Date.parse(v) !== NaN) {
          // v = (new Date(v)).getTime();
        }

        res.series[ci].data.push(v);
      });
    });

    return res;
  }
